
import './App.css';
import {BrowserRouter,Routes, Route} from "react-router-dom"

import TopPage from "./pages/TopPage"
import InfoPage from "./pages/InfoPage"
import AppPage from "./pages/AppPage"
import QformPage from "./pages/QformPage"
import Error404 from "./pages/Error404"
import AppBarBox from "./components/AppBarBox"


function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<TopPage />} />
        <Route path="/info" element={
          <AppBarBox menuWord="info">
            <InfoPage />
          </AppBarBox>
        } />
        <Route path="/app" element={
          <AppBarBox menuWord="app">
            <AppPage />
          </AppBarBox>
        } />
        <Route path="/contact" element={
          <AppBarBox menuWord="contact">
            <QformPage />
          </AppBarBox>
        } />
        <Route path="*" element={<Error404 />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
